import { getViewport, parseQueryString } from "../helpers";


// TODO: Mutation Observer
/**
 * Mutation Observer
 */



// TODO: Mutation Observer
/**
 * Mutation Observer
 */


/**
 * onReady
 */
let hasRun = false;
let windowWidth = window.innerWidth;

const onReady = () => {

	/** --- Setup our base store --- */
	window.Zero = window.Zero || {};

	/** --- Measurements --- */
	try {
		window.Zero.queryParams = parseQueryString();
	} catch(err){
		window.Zero.queryParams = undefined;
	}

	window.Zero.windowHeight = getViewport().height;
	window.Zero.windowWidth = getViewport().width;

	/** --- vh variable set --- */
	let vh = getViewport().height * 0.01;

	document.body.style.setProperty('--vh', `${vh}px`);

	/** --- Init animations & components --- */
	if(hasRun === true) return;

	window.Zero.animation.init();
	window.Zero.components.init();

	if(window.Zero.page) window.Zero.page.init();

	/** --- Bind custom events --- */
	window.Zero.dispatches = {
		animate: new Event("animate"),
		history: new Event("history"),
		resized: new Event("resized"),
		enter: new Event("viewportEnter"),
		exit: new Event("viewportExit")
	};

	window.Zero.events.animate = window.Zero.events.animate || [];
	window.Zero.events.history = window.Zero.events.history || [];
	window.Zero.events.resized = window.Zero.events.resized || [];
	window.Zero.events.observed = window.Zero.events.observed || [];

	hasRun = true;
};

/**
 * onLoad
 */
const onLoad = () => {

	window.Zero = window.Zero || {};

	window.Zero.scroll = window.Zero.scroll || {};
	window.Zero.scroll.current = window.scrollY;
	window.Zero.scroll.last = null;

	window.Zero.lazyLoad.update(); // HACK: Force update after all is loaded
};

/** Window Resize */
let resizeTimeout;

/**
 * onResize
 */
const onResize = () => {

	if (window.innerWidth == windowWidth) return;

	windowWidth = window.innerWidth;

	/** Need to delay this if user is actively resizing window */
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(()=>{

		window.Zero = window.Zero || {};
		window.Zero.windowHeight = getViewport().height;
		window.Zero.windowWidth = getViewport().width;

		let vh = getViewport().height * 0.01;

		document.body.style.setProperty('--vh', `${vh}px`);

		window.Zero.events.resized.forEach((el) => el.dispatchEvent(window.Zero.dispatches.resized));

	}, 300);
};

/**
 * onScroll
 * @returns
 */
const onScroll = ()=>{

	/** Grab scroll */
	window.Zero = window.Zero || {};
	window.Zero.scroll = window.Zero.scroll || {};
	window.Zero.scroll.current = window.scrollY;

	/** Set up first load */
	if(window.Zero.scroll.last === null){

		window.Zero.scroll.last = window.Zero.scroll.current;

		return;
	}

	/** Bounce if equal */
	if(window.Zero.scroll.current === window.Zero.scroll.last){

		window.Zero.scroll.direction.dir = "idle";

		return;
	}

	// TODO: extend with maybe acceleration

	/** Set direction */
	if(window.Zero.scroll.current > window.Zero.scroll.last && window.Zero.scroll.direction.dir != "down") window.Zero.scroll.direction.dir = "down";
	if(window.Zero.scroll.current < window.Zero.scroll.last && window.Zero.scroll.direction.dir != "up") window.Zero.scroll.direction.dir = "up";

	window.Zero.scroll.last = window.Zero.scroll.current;

	// TODO: bind customElement with scroll values
	// TODO: Does this bind to animation instead?
};

/**
 * onHistoryChange
 */
const onHistoryChange = () => {
	window.Zero.events.history.forEach((el) => el.dispatchEvent(window.Zero.dispatches.history));
}

/** Attach Events */
document.addEventListener("DOMContentLoaded", onReady);
window.addEventListener("load", onLoad.bind(this));
window.addEventListener("resize", onResize.bind(this));
window.addEventListener("scroll", onScroll.bind(this));
window.addEventListener("popstate", onHistoryChange.bind(this));
